import React, {Component} from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import {getConfig, getConfusionBetween} from "../global/API";
import ReactTooltip from "react-tooltip";
import "../css/Matrix.css";


export default class ResponsiveMatrix extends Component{

    constructor(props) {
        super(props);
        this.state = {
            confusion: "",
            marked: [],
            sombreado:{
                x:undefined,
                y:undefined,
            }
        };
        this.columnClicked = this.columnClicked.bind(this);
    }
    async componentDidMount() {
        var response = await getConfig(
            this.props.dataset,
            this.props.language.id,
            this.props.token
        );

        if (response.error) {
            if (response.status === 401) {
                this.props.handleGlobalMessage(
                    "error",
                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                );
                this.props.closeSession();
                this.setState({
                    redirect: true
                });
            } else {
                this.setState({
                    error: true,
                    message: response.data.message
                });
            }
        } else {
            this.setState(
                {
                    consequents: response.data.consequents
                });
        }
    }
    async columnClicked(row, column) {
        this.setState({
            sombreado:{x:row,y:column}
        })
        var consequentA = this.state.consequents[row];
        var consequentB = this.state.consequents[column];
        var consequents;
        if (consequentB) consequents = [consequentA, consequentB];
        else consequents = [consequentA];

        const response = await getConfusionBetween(
            this.props.dataset,
            this.props.algorithm,
            consequents,
            this.props.language.id,
            this.props.token,
            this.props.type
        );

        if (response.error) {
            if (response.status === 401) {
                this.props.handleGlobalMessage(
                    "error",
                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                );
                this.props.closeSession();
                this.setState({
                    redirect: true
                });
            } else {
                this.setState({
                    error: true,
                    message: response.data
                });
            }
        } else {
            this.props.updateMatrixExplanation(response.data.clauses);
        }
    }

    render() {
        if(this.state.consequents!=null) {
            var anchoNumero = 90 / (this.state.consequents.length + 1);
            var ancho = anchoNumero + "%";
        }
        return (
                <Paper id={"rootTable"}>
                    <Table id={"table"}>
                        <TableBody>
                            <TableRow style={{height:ancho}}>
                                <TableCell style={{width:ancho}} id={"cellFirst"}></TableCell>
                                {this.state.consequents!=null &&
                                this.state.consequents.map((consequent,rowIndex) => {
                                    return <TableCell id={"cellHead"}>{consequent.name.charAt(0).toUpperCase()+(consequent.name).slice(1)}</TableCell>
                                })}
                                {this.state.consequents!=null &&
                                this.state.consequents.map((consequent,rowIndex) => {
                                    return <TableCell data-tip data-for={consequent.name}id={"cellHeadIndex"}>{rowIndex}
                                            <ReactTooltip place="top" type="dark" effect="float"  id={consequent.name}>
                                                <p>{consequent.name.charAt(0).toUpperCase()+(consequent.name).slice(1)}</p>
                                            </ReactTooltip>
                                        </TableCell>
                                })}
                            </TableRow>
                            {this.state.consequents!=null &&
                            this.props.matrix.data.map((row, rowIndex) => {
                                var sum = this.props.sum[rowIndex];
                                return (<TableRow style={{height:ancho}} key={rowIndex}>
                                    <TableCell  style={{height:ancho}} id={"cellHeadColumn"}>{this.state.consequents[rowIndex].name.charAt(0).toUpperCase()+(this.state.consequents[rowIndex].name).slice(1)}</TableCell>
                                    <TableCell   data-tip data-for={this.state.consequents[rowIndex].name+"column"}style={{height:ancho}} id={"cellHeadColumnIndex"}>{rowIndex}
                                        <ReactTooltip place="top" type="dark" effect="float"  id={this.state.consequents[rowIndex].name+"column"}>
                                            <p>{this.state.consequents[rowIndex].name.charAt(0).toUpperCase()+(this.state.consequents[rowIndex].name).slice(1)}</p>
                                        </ReactTooltip></TableCell>
                                        {row.map((column, index) => {
                                        var color;
                                        var background;
                                        var font;
                                        var border;

                                        if (rowIndex !== index) {
                                            if(sum===0){
                                                color=255
                                            }else {
                                                color = -((column / sum) * 255) + 255;
                                            }
                                            background = "rgb(" + 255 + "," + color + "," + color + ")";
                                            font = color < 100 ? "white" : "black";
                                        } else {
                                            background = "#4caf50";
                                            font = "white";
                                        }
                                        if(rowIndex===this.state.sombreado.x && index===this.state.sombreado.y){
                                            border="5px solid black"
                                        }
                                        return <TableCell  onClick={()=>this.columnClicked(rowIndex,index)} style={{width:ancho,backgroundColor:background,color:font,border:border}} id={"cell"} component="th" scope="row">
                                            {column}
                                        </TableCell>
                                })}
                                </TableRow>)
                            })
                            }
                        </TableBody>
                    </Table>
                </Paper>
            );
        }
}
